var _rect, _rect2, _rect3, _path, _path2, _path3, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16,
    rx: 2,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_239_33482",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 16
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16,
    rx: 2,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_239_33482)"
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16,
    fill: "#05AB41"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.23059 8.5707C2.80122 8.3114 2.80122 7.68866 3.23059 7.42936L11.6553 2.3415C11.8672 2.21351 12.1326 2.21351 12.3446 2.3415L20.7693 7.42936C21.1986 7.68866 21.1986 8.3114 20.7693 8.5707L12.3446 13.6586C12.1326 13.7866 11.8672 13.7866 11.6553 13.6586L3.23059 8.5707Z",
    fill: "#FDD216"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.7333C14.2091 11.7333 16 10.0619 16 8C16 5.93813 14.2091 4.26666 12 4.26666C9.79086 4.26666 8 5.93813 8 8C8 10.0619 9.79086 11.7333 12 11.7333Z",
    fill: "#053087"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_239_33482",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 4,
    width: 8,
    height: 8
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.7333C14.2091 11.7333 16 10.0619 16 8C16 5.93813 14.2091 4.26666 12 4.26666C9.79086 4.26666 8 5.93813 8 8C8 10.0619 9.79086 11.7333 12 11.7333Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_239_33482)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5257 7.02421C8.15373 6.54955 10.1803 6.99921 12.0721 7.4702C13.9639 7.9412 15.9369 8.92841 16.4393 9.50743",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "square"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBr);
export default __webpack_public_path__ + "static/media/BR.de6d915360146cf96077fd7246191991.svg";
export { ForwardRef as ReactComponent };